import { Directive } from '@angular/core'

@Directive({
    selector: '[tidyLabel]',
    standalone: false
})
export class TidyLabelDirective { }
